import { render, staticRenderFns } from "./ReportsIcon.vue?vue&type=template&id=6422d256&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422d256",
  null
  
)

export default component.exports